import './Footer.css'
import React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import TwitterIcon from '@mui/icons-material/Twitter';
import GoogleIcon from '@mui/icons-material/Google';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import HomeIcon from '@mui/icons-material/Home';
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import DiamondIcon from '@mui/icons-material/Diamond';

export default function Footer() {
  return (
    <div class="footer">
        <br/>
        <Container maxWidth="xl">
          <Grid container>
            <Grid xs={12} sm={6} md={3}>
              <div class="footer-info">
              <Typography style={{fontWeight: 'bold', margin: '0.5vw'}}>კონტაქტი</Typography>
              </div>
              <div class="footer-info">
              <HomeIcon/>
              <Typography style={{margin: '0.5vw'}}><a href='https://www.google.com/maps/place/%E1%83%A1%E1%83%94%E1%83%A0%E1%83%92%E1%83%9D+%E1%83%96%E1%83%90%E1%83%A5%E1%83%90%E1%83%A0%E1%83%98%E1%83%90%E1%83%AB%E1%83%98%E1%83%A1+%E1%83%A1%E1%83%90%E1%83%AE%E1%83%94%E1%83%9A%E1%83%9D%E1%83%91%E1%83%98%E1%83%A1+%E1%83%A2%E1%83%A0%E1%83%90%E1%83%93%E1%83%98%E1%83%AA%E1%83%98%E1%83%A3%E1%83%9A%E1%83%98+%E1%83%93%E1%83%90+%E1%83%97%E1%83%90%E1%83%9C%E1%83%90%E1%83%9B%E1%83%94%E1%83%93%E1%83%A0%E1%83%9D%E1%83%95%E1%83%94+%E1%83%AE%E1%83%94%E1%83%9A%E1%83%9D%E1%83%95%E1%83%9C%E1%83%94%E1%83%91%E1%83%98%E1%83%A1+%E1%83%99%E1%83%9D%E1%83%9A%E1%83%94%E1%83%AF%E1%83%98/@41.7122282,44.7996631,15z/data=!4m6!3m5!1s0x40440df88a93048f:0x33f47760b17b0005!8m2!3d41.7122282!4d44.7996631!16s%2Fg%2F11stpl2q9b' target='_blank'>ივ. ჯავახიშვილის 88, თბილისი</a></Typography>
              </div>
              <div class="footer-info">
              <MailIcon/>
              <a href='mailto:gisolutions@example.com' style={{margin: '0.5vw'}}><Typography >zaqariadzelebi@gmail.com</Typography></a>
              </div>
              <div class="footer-info">
              <PhoneIcon/>
              <Typography style={{margin: '0.5vw'}}>+995 32 295 30 84</Typography>
              </div><br/>
            </Grid>
            <Grid xs={12} sm={6} md={3}>
              <div class="footer-info">
              <Typography style={{fontWeight: 'bold', margin: '0.5vw'}}>სერვისები</Typography>
              </div>            
              <div class="footer-info">
              <a href='#about' style={{margin: '0.5vw'}}><Typography >ჩვენ შესახებ</Typography></a>
              </div>
              {/* <div class="footer-info">
              <a href='#team' style={{margin: '0.5vw'}}><Typography >დამფუძნებლები</Typography></a>
              </div> */}
              <div class="footer-info">
              <a href='#contacts' style={{margin: '0.5vw'}}><Typography >კონტაქტი</Typography></a>
              </div><br/>
            </Grid>
            <Grid xs={12} sm={6} md={3}>             
              <div class="link-text">
            <Typography textAlign="left" style={{fontWeight: 'bold'}}>სოციალური ქსელები</Typography>
            </div> 
            <div class="links">
            <a target='_blank' href='https://www.facebook.com/people/სერგო-ზაქარიაძის-სახელობის-ტრადიციული-და-თანამედროვე-ხელოვნების-კოლეჯი/100063752280274/'>
            <FacebookOutlinedIcon/>
            </a>
            <br/>
            <a target='_blank'  href='https://www.instagram.com/zaqariadzelebi/'>
            <InstagramIcon/>
            </a>
            </div>
            </Grid>
            <Grid xs={12} sm={6} md={3}>
              <div class="footer-info">
                <Typography style={{fontWeight: 'bold', margin: '0.5vw'}}>სერგო ზაქარიაძის სახელობის ტრადიციული და თანამედროვე ხელოვნების კოლეჯი</Typography>
              </div>    
            </Grid>
          </Grid>
        </Container>
          <div class='footer_copy'>
            <Typography style={{fontWeight: 'bold'}}>POWERED BY &copy;&nbsp;</Typography>
            <a target='_blank' href='https://gemini-impulse-solutions.vercel.app/'><Typography style={{fontWeight: 'bold'}}>GIS&nbsp;</Typography></a>
            <Typography style={{fontWeight: 'bold'}}>Since 2022</Typography>
          </div>    
    </div>
  );
}
